<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-fm"><a href="#/006_Ack#fm-1"><em>Acknowledgments</em></a></p>
<p class="toc-fmt"><a href="#/007_Introduction#fm-2">Introduction: The Value of Skepticism in the Christian Life</a></p>
<p class="toc-chap"><a href="#/008_Chapter01#ch-1">1.<span class="toc">The Breadth of the Miraculous in the Bible</span></a></p>
<p class="toc-chap"><span href="#/009_Chapter02#ch-2" title="Link target outside of Sample">2.<span class="toc">Jesus the Miracle Worker</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="toc">Jesus and the Natural World</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="toc">Jesus and the Demonic</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="toc">If Jesus Did That Then, Why Not Now?</span></span></p>
<p class="toc-chap"><span href="#/013_Chapter06#ch-6" title="Link target outside of Sample">6.<span class="toc">Virginal Laptop</span></span></p>
<p class="toc-chap"><span href="#/014_Chapter07#ch-7" title="Link target outside of Sample">7.<span class="toc">Learning to Love the Weird Parts of the Bible</span></span></p>
<p class="toc-bm"><span href="#/015_Reading#bm-1" title="Link target outside of Sample"><em>Recommended Readings</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?e28f2e2c